const TABBABLE =
  'button:not(:disabled), a[href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]';

const dialogs: HTMLElement[] = [];

/** Contain keyboard/programmatic focus and restore the invoking control when a dialog unmounts. */
export function containDialogFocus(dialog: HTMLElement, initial: HTMLElement = dialog) {
  const doc = dialog.ownerDocument;
  const previous = doc.activeElement;
  dialogs.push(dialog);
  const focusables = () =>
    [...dialog.querySelectorAll<HTMLElement>(TABBABLE)].filter(
      (el) => !el.hidden && el.getClientRects().length > 0,
    );
  const onKey = (e: KeyboardEvent) => {
    if (dialogs.at(-1) !== dialog || e.key !== "Tab") return;
    const list = focusables();
    const index = list.indexOf(doc.activeElement as HTMLElement);
    if (e.shiftKey ? index <= 0 : index < 0 || index === list.length - 1) {
      e.preventDefault();
      (e.shiftKey ? (list.at(-1) ?? initial) : (list[0] ?? initial)).focus();
    }
  };
  const onFocus = (e: FocusEvent) => {
    if (dialogs.at(-1) === dialog && !dialog.contains(e.target as Node)) initial.focus();
  };
  dialog.addEventListener("keydown", onKey);
  doc.addEventListener("focusin", onFocus);
  initial.focus();
  return () => {
    dialog.removeEventListener("keydown", onKey);
    doc.removeEventListener("focusin", onFocus);
    const index = dialogs.lastIndexOf(dialog);
    if (index >= 0) dialogs.splice(index, 1);
    if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
  };
}
